import { useState } from "react";
import { ErrorPanel, Skeleton } from "@/components/atoms";
import { EmptyState } from "@/components/molecules";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useGetVehiclesQuery } from "@/redux/apis/vehicle/vehicleApi";
import { Vehicle } from "@/redux/slices/vehicle/types";
import { ArchiveVehicleModal } from "../MyVehicles/modals/ArchiveVehicleModal";
import { AffiliateVehiclesTable } from "./AffiliateVehiclesTable";
import { useGetAffiliateVehiclesParams } from "./hooks/useGetAffiliateVehiclesParams";

export const AffiliateVehiclesPanel = () => {
  const { params } = useGetAffiliateVehiclesParams();
  const {
    isFetching,
    data: response,
    error,
  } = useGetVehiclesQuery(params, {
    refetchOnMountOrArgChange: true,
  });
  const [pendingArchive, setPendingArchive] = useState<Vehicle | undefined>();

  if (error) return <ErrorPanel messages={getErrorMessages(error)} />;
  if (isFetching) return <Skeleton />;

  if (response && response.vehicles.length > 0)
    return (
      <>
        <AffiliateVehiclesTable items={response.vehicles ?? []} setPendingArchive={setPendingArchive} />
        <AffiliateVehiclesTable.Pagination page={response.page} />
        <ArchiveVehicleModal pendingArchive={pendingArchive} setPendingArchive={setPendingArchive} />
      </>
    );

  return <EmptyState title="Vehicle Manager" description="There are no vehicles matching your filter criteria at the moment." />;
};
